"use client";

import Flex from "@/shared/components/common/Flex";
import Typography from "@/shared/components/common/Typography";
import { Button } from "@/shared/components/common/button";
import { scrollToElement } from "@/shared/libs/commonUtils";
import type { WebsiteSettings } from "@/types/services/public/apis/Settings";
interface GetStartedProps {
  settings: WebsiteSettings;
}
export default function GetStarted({
  settings
}: GetStartedProps) {
  const {
    text,
    button_text
  } = settings.slogan;
  const handleScrollToHero = () => {
    scrollToElement("hero-section", 1000);
  };
  return <Flex className="justify-between items-center max-md:flex-col max-md:gap-y-4 max-sm:px-4 max-md:text-center" data-sentry-element="Flex" data-sentry-component="GetStarted" data-sentry-source-file="GetStarted.tsx">
      <Flex alignItems={"center"} className="gap-x-2 max-sm:w-full max-md:justify-center" data-sentry-element="Flex" data-sentry-source-file="GetStarted.tsx">
        <Button id="#hero-section" onClick={handleScrollToHero} size={"lg"} className="max-sm:w-full !bg-background hover:!bg-primary text-muted-foreground hover:text-background rounded-full ring-1 ring-border shadow-none group transition duration-100 ease-ease-in-out-circ hover:border-primary" data-sentry-element="Button" data-sentry-source-file="GetStarted.tsx">
          {button_text}
        </Button>
      </Flex>

      <Typography variant="body1" className="font-medium text-muted-foreground dark:text-muted max-sm:text-sm" data-sentry-element="Typography" data-sentry-source-file="GetStarted.tsx">
        {text}
      </Typography>
    </Flex>;
}